import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";
import { CONFIG } from "@/config";

export const StickyBar = ({ onClick }) => {
  const t = CONFIG.nextSteps;
  return (
    <motion.div
      className="fixed inset-x-0 bottom-0 z-40 px-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] sm:px-6 sm:pb-5"
      initial={{ y: 120, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: 0.4 }}
      data-testid="sticky-bottom-bar"
    >
      <div className="glass mx-auto flex max-w-3xl items-center justify-between gap-3 rounded-2xl px-4 py-3 sm:px-6 sm:py-4">
        <div className="min-w-0">
          <p className="truncate text-sm font-medium text-[#F4F5F2]">{t.stickyText}</p>
          <p className="hidden sm:block text-xs text-[#A3A89E]">Pick the option that fits you best.</p>
        </div>
        <button type="button" onClick={onClick} className="btn-primary shrink-0 !px-4 sm:!px-6" data-testid="btn-sticky-cta">
          <span className="hidden sm:inline">{t.stickyButtonText}</span>
          <span className="sm:hidden">Next step</span>
          <ArrowDown className="h-4 w-4" />
        </button>
      </div>
    </motion.div>
  );
};
